export default function flat(array) {
  var _ref;
  return (_ref = []).concat.apply(_ref, array);
}